<template>
  <div class="item f-left">
    <div class="cover-wrap" @click="goToRead">
      <img class="cover" :src="item.cover_img" />
    </div>
    <div class="right">
      <div class="title-wrap" @click="goToRead">
        <span class="title">{{ item.name }}</span>
      </div>
      <div class="author">作者：{{ item.author }}</div>
      <div class="time" v-if="item.last_read_time">
        阅读时间：{{ item.last_read_time | tsFormatLong }}
      </div>
      <div class="time" v-else>阅读时间：-</div>
      <div class="bottom">
        <div class="progress-box">
          <!-- 需求调整：去掉进度条显示 -->
          <!-- <el-progress
            status="success"
            :show-text="false"
            :stroke-width="5"
            color="#4ED293"
            :percentage="parseFloat(item.progress)"
          ></el-progress>
          <span>{{ item.progress }}%</span> -->
        </div>
        <div class="btn-read" :class="item.progress > 0 ? 'has-read' : ''" @click="goToRead">
          {{ item.is_complete == 1 ? '再次阅读' : item.progress > 0 ? '继续阅读' : '开始阅读' }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EBooksItem',
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    goToRead() {
      this.$router.push(`/ebooks/reader/${this.item.id}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  width: 440px;
  height: 202px;
  box-sizing: border-box;
  margin-bottom: 32px;
  margin-right: 24px;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background-color: white;
  display: flex;
  &:hover {
    box-shadow: 0px 3px 15px 0px rgba(224, 224, 224, 1);
    .cover {
      transform: scale(1.1);
    }
  }
  &:nth-child(2n) {
    margin-right: 0;
  }
  .cover-wrap {
    width: 140px;
    margin-right: 20px;
    overflow: hidden;
    flex-shrink: 0;
    border-radius: 6px 0 0 6px;
    cursor: pointer;
  }
  .cover {
    border-radius: 6px 0 0 6px;
    width: 100%;
    height: 100%;
    transform: scale(1);
    transition: 0.5s all;
  }
  .right {
    flex-grow: 1;
    padding-right: 24px;
    overflow: hidden;
  }
  .title-wrap {
    display: flex;
    align-items: center;
    overflow: hidden;
    margin-top: 16px;
    cursor: pointer;
  }
  .title {
    flex-grow: 1;
    font-size: 15px;
    font-weight: 500;
    color: #333;
    line-height: 24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:hover {
      color: $primary-color;
    }
  }

  .author {
    height: 24px;
    font-size: 13px;
    color: #999999;
    line-height: 24px;
    // margin: 12px 0 36px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    margin: 16px 0 8px 0;
  }
  .time {
    font-size: 13px;
    color: #999999;
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 34px;
    .progress-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      color: #333333;
    }
    ::v-deep .el-progress--line {
      width: 80px;
      margin-right: 5px;
    }
    .btn-read {
      width: 84px;
      height: 34px;
      background: #f4242e;
      border-radius: 4px;
      color: #ffffff;
      font-size: 14px;
      line-height: 34px;
      text-align: center;
      cursor: pointer;
      &.has-read {
        color: $primary-color;
        background: #ffffff;
        border: 1px solid $primary-color;
      }
    }
  }
}
</style>
